/**
 * Scroll to Top Button
 * Shows/hides based on scroll position and handles smooth scrolling
 */

(function() {
  'use strict';

  const scrollTopButton = document.getElementById('scrollTop');

  if (!scrollTopButton) {
    return;
  }

  // Scroll threshold from theme config (default 400px)
  const scrollThreshold = 400;
  let isVisible = false;

  // Show/hide button based on scroll position
  function updateScrollTopVisibility() {
    const shouldShow = window.pageYOffset > scrollThreshold;

    if (shouldShow && !isVisible) {
      scrollTopButton.classList.add('visible');
      isVisible = true;
    } else if (!shouldShow && isVisible) {
      scrollTopButton.classList.remove('visible');
      isVisible = false;
    }
  }

  // Scroll to top with smooth behavior
  function scrollToTop(e) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  // Event listeners
  scrollTopButton.addEventListener('click', scrollToTop);

  // Throttle scroll event for better performance
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    if (scrollTimeout) {
      window.cancelAnimationFrame(scrollTimeout);
    }
    scrollTimeout = window.requestAnimationFrame(updateScrollTopVisibility);
  }, { passive: true });

  // Initial check
  updateScrollTopVisibility();
})();
